import { RootType } from "@/models/lookup-tables/lookup-tables.dto";
import { useLocationsContext } from "@/pages/configurations/locations/context/Location";
import { Location } from "@/pages/configurations/locations/models/Location/Location";
import { useRootTypeContext } from "@/pages/configurations/rootTypes/context/RootTypeContext";
import { cellActionsStyle, rowIconButtonStyle } from "@/utils/ag-grid-defaults";
import { Button, Grid } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { ColDef } from "ag-grid-community";
import { find } from "lodash-es";
import { useMemo } from "react";
import { useRootContext } from "../../../context/RootContext";
import { useRootStateContext } from "../../../context/RootStateContext";
import { RootState } from "../../../models/RootState/RootState";

type Props = {
	/*  gridRef:Function, */
	setRootIdForEdit: Function;
	setModalEditRoot: Function;
	setRootIdForDelete: Function;
	setModalDeleteRoot: Function;
	setCommentsModal: Function;
};

export const useTableData = ({
	setRootIdForEdit,
	setModalEditRoot,
	setRootIdForDelete,
	setModalDeleteRoot,
	setCommentsModal,
}: Props) => {
	const {
		state: { locations },
	} = useLocationsContext();
	const {
		state: { roots },
	} = useRootContext();
	const {
		state: { rootTypes },
	} = useRootTypeContext();
	const {
		state: { rootStates },
	} = useRootStateContext();

	const columns: ColDef[] = [
		{
			field: "rootId",
			headerName: "  ",
			width: 70,
		},
		{
			field: "rootName",
			headerName: "Name",
		},
		{
			field: "rootTypeId",
			headerName: "Root Type",
			filter: "agSetColumnFilter",
		},
		{
			field: "isActive",
			headerName: "Status",
		},
		{
			field: "Actions",
			cellRenderer: (params: any) => {
				return (
					<span style={cellActionsStyle}>
						<Button
							size="small"
							style={rowIconButtonStyle}
							onClick={() => {
								setRootIdForEdit(params.data.rootId);
								setModalEditRoot(true);
							}}
						>
							<EditIcon style={{ width: 18, height: 18 }} color="primary" />
						</Button>
						<Button
							size="small"
							style={rowIconButtonStyle}
							onClick={() => {
								setRootIdForDelete(params.data.rootId);
								setModalDeleteRoot(true);
							}}
						>
							<DeleteIcon style={{ width: 18, height: 18 }} color="secondary" />
						</Button>
					</span>
				);
			},
			headerName: " ",
			sortable: false,
			maxWidth: 100,
		},
	];

	const defaultColDef = useMemo(
		() => ({
			innerWidth: "500px",
			resizable: true,
			sortable: true,
			filter: true,
			suppressMenu: true,
		}),
		[],
	);

	const rows = roots.map(
		({
			rootId,
			rootName,
			rootTypeId,
			isActive,
			locationId,
			rootStateId,
			stateComments,
			needsAttention,
			attentionComments,
			supervisorInstructions,
			workerComments,
		}) => {
			const rootType: RootType | undefined = find(rootTypes, [
				"rootTypeId",
				rootTypeId,
			]);
			const rootState: RootState | undefined = find(rootStates, [
				"rootStateId",
				rootStateId,
			]);
			const location: Location | undefined = find(locations, [
				"locationId",
				locationId,
			]);

			return {
				rootId,
				rootName,
				rootTypeId: rootType?.rootTypeName,
				isActive: isActive ? "Active" : "Inactive",
				locationId: location?.locationName,
				rootStateId: rootState?.rootStateName,
				stateComments,
				needsAttention: needsAttention ? "Yes" : "No",
				attentionComments,
				supervisorInstructions,
				workerComments,
				id: rootId,
			};
		},
	);
	return { rows, columns, defaultColDef };
};
